export default __webpack_public_path__ + "static/media/@jaqueestacomendo.e50a3def.jpg";